import React, { useState } from 'react';
import { LinkedinIcon, MailIcon, PhoneIcon, SendIcon } from 'lucide-react';
import { Button } from '../components/Button';
import { SectionHeading } from '../components/SectionHeading';
export function Contact() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormState(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      // Reset form
      setFormState({
        name: '',
        email: '',
        company: '',
        message: ''
      });
    }, 1500);
  };
  return <div className="bg-cream" data-id="element-711">
      <section className="py-16 md:py-24" data-id="element-712">
        <div className="container mx-auto px-6" data-id="element-713">
          <SectionHeading title="Get in Touch" subtitle="I'm currently exploring new opportunities in health-tech and wellness" centered data-id="element-714" />
          <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-715">
            <div className="md:col-span-1" data-id="element-716">
              <div className="bg-white rounded-lg shadow-sm p-6 space-y-8" data-id="element-717">
                <div data-id="element-718">
                  <h3 className="text-lg font-display font-semibold text-navy-dark mb-3" data-id="element-719">
                    Contact Information
                  </h3>
                  <p className="text-navy text-sm mb-6" data-id="element-720">
                    Feel free to reach out through any of these channels.
                  </p>
                  <div className="space-y-4" data-id="element-721">
                    <a href="mailto:emma0rose@gmail.com" className="flex items-center text-navy hover:text-coral-dark transition-colors" data-id="element-722">
                      <MailIcon size={18} className="mr-3" data-id="element-723" />
                      <span data-id="element-724">emma0rose@gmail.com</span>
                    </a>
                    <a href="tel:+447570039548" className="flex items-center text-navy hover:text-coral-dark transition-colors" data-id="element-725">
                      <PhoneIcon size={18} className="mr-3" data-id="element-726" />
                      <span data-id="element-727">+44 7570 039548</span>
                    </a>
                    <a href="https://linkedin.com/in/emma-rose" target="_blank" rel="noopener noreferrer" className="flex items-center text-navy hover:text-coral-dark transition-colors" data-id="element-728">
                      <LinkedinIcon size={18} className="mr-3" data-id="element-729" />
                      <span data-id="element-730">linkedin.com/in/emma-rose</span>
                    </a>
                  </div>
                </div>
                <div data-id="element-731">
                  <h3 className="text-lg font-display font-semibold text-navy-dark mb-3" data-id="element-732">
                    Looking For
                  </h3>
                  <p className="text-navy text-sm" data-id="element-733">
                    Lead Product Manager, Head of Product, or Senior Product
                    Manager roles in health-tech, women's health, nutrition,
                    wellness, and fitness companies with a mission to make
                    health and wellbeing more accessible.
                  </p>
                </div>
              </div>
            </div>
            <div className="md:col-span-2" data-id="element-734">
              <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-735">
                {isSubmitted ? <div className="text-center py-8" data-id="element-736">
                    <div className="w-16 h-16 bg-sage-light rounded-full flex items-center justify-center mx-auto mb-6 text-sage-dark" data-id="element-737">
                      <SendIcon size={24} data-id="element-738" />
                    </div>
                    <h3 className="text-xl font-display font-semibold text-navy-dark mb-3" data-id="element-739">
                      Message Sent!
                    </h3>
                    <p className="text-navy mb-6" data-id="element-740">
                      Thank you for reaching out. I'll get back to you as soon
                      as possible.
                    </p>
                    <Button onClick={() => setIsSubmitted(false)} variant="secondary" data-id="element-741">
                      Send Another Message
                    </Button>
                  </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-742">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-743">
                      <div data-id="element-744">
                        <label htmlFor="name" className="block text-sm font-medium text-navy-dark mb-1" data-id="element-745">
                          Name
                        </label>
                        <input type="text" id="name" name="name" value={formState.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-coral-dark" data-id="element-746" />
                      </div>
                      <div data-id="element-747">
                        <label htmlFor="email" className="block text-sm font-medium text-navy-dark mb-1" data-id="element-748">
                          Email
                        </label>
                        <input type="email" id="email" name="email" value={formState.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-coral-dark" data-id="element-749" />
                      </div>
                    </div>
                    <div data-id="element-750">
                      <label htmlFor="company" className="block text-sm font-medium text-navy-dark mb-1" data-id="element-751">
                        Company
                      </label>
                      <input type="text" id="company" name="company" value={formState.company} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-coral-dark" data-id="element-752" />
                    </div>
                    <div data-id="element-753">
                      <label htmlFor="message" className="block text-sm font-medium text-navy-dark mb-1" data-id="element-754">
                        Message
                      </label>
                      <textarea id="message" name="message" rows={5} value={formState.message} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-coral-dark" data-id="element-755"></textarea>
                    </div>
                    {error && <div className="text-red-500 text-sm" data-id="element-756">{error}</div>}
                    <Button type="submit" disabled={isSubmitting} className="w-full" data-id="element-757">
                      {isSubmitting ? 'Sending...' : 'Send Message'}
                    </Button>
                  </form>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}